import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BackendService } from '../../../core/services/backend/backend.service';
import { Observable, map, tap } from 'rxjs';

interface IGender{
  gender_id: number,
  slug: string,
  name: string,
  icon: string
}

@Injectable({
  providedIn: 'root'
})
export class ListGender {

  public genders:  Array<IGender>;

  http = inject(HttpClient);
  private backend = inject(BackendService);

  constructor() { }

  loading(){
    this.loadingForLanguageChange().subscribe();
  }

  loadingForLanguageChange(): Observable<void>{
    return this.http.get<any>(`${this.backend.getApiUrl()}/global-info`).pipe(
      tap(result => this.genders = result.genders),
      map(() => undefined)
    );
  }

  findGender(id: number){
    return this.genders.find((item: IGender) => item.gender_id === id);
  }
}
